import RouteService from '@/services/RouteService'

// initial state
const state = {
	currentRoute: null
}

// actions
const actions = {
	setCurrentRoute({ commit }, route) {
		// if (route && !route.orders) {
		if (route) {
			return RouteService.find(route.id).then(res => {
				const data = res.data['member'] || res.data['hydra:member'] || res.data
				commit('SET_CURRENT_ROUTE', Array.isArray(data) ? data[0] : data)
			})
		} else commit('SET_CURRENT_ROUTE', route)
	},
	getActiveRoutes(store, filter) {
		return RouteService.getAll({ field: 'id', order: 'desc' }, 999999, 1, filter).then(
			res => res.data['member'] || res.data['hydra:member'] || []
		)
	},
	updateRoute({ commit, state }) {
		return RouteService.update(state.currentRoute).then(res => {
			commit('SET_CURRENT_ROUTE', res.data)
			return state.currentRoute
		})
	},
	updateRouteStatus({ commit, dispatch }, status) {
		commit('SET_ROUTE_STATUS', status)
		return dispatch('updateRoute')
	},
	updateRouteStartPoint({ commit, dispatch }, startPoint) {
		commit('SET_ROUTE_START_POINT', startPoint)
		return dispatch('updateRoute')
	},
	updateRouteOrdersOrder({ commit, dispatch }, ordersIds) {
		commit('SET_ROUTE_ORDERS_ORDER', ordersIds)
		return dispatch('updateRoute')
	},
	updateRouteOrdersOrderAndDistances({ commit, dispatch }, { sortedOrdersIds, distances }) {
		commit('SET_ROUTE_ORDERS_ORDER_AND_DISTANCES', { sortedOrdersIds, distances })
		return dispatch('updateRoute')
	},
	archiveRoute({ commit, dispatch }) {
		commit('SET_ROUTE_STATUS', 'archived')
		return dispatch('updateRoute')
	},
	deleteRoute({ commit, state }) {
		const routeToDestroy = state.currentRoute
		return RouteService.destroy(routeToDestroy).then(() => {
			commit('SET_CURRENT_ROUTE', null)
			return routeToDestroy
		})
	}
}

// mutations
const mutations = {
	SET_CURRENT_ROUTE(state, route) {
		state.currentRoute = Object.assign({}, route) // remove reference
	},
	SET_ROUTE_STATUS(state, status) {
		state.currentRoute.status = status
	},
	SET_ROUTE_START_POINT(state, startPoint) {
		state.currentRoute.startPoint = startPoint ? JSON.stringify(startPoint) : startPoint
	},
	SET_ROUTE_ORDERS_ORDER(state, ordersIds) {
		state.currentRoute.ordersIds = ordersIds
	},
	SET_ROUTE_ORDERS_ORDER_AND_DISTANCES(state, { sortedOrdersIds, distances }) {
		state.currentRoute.ordersIds = sortedOrdersIds
		state.currentRoute.ordersDistances = distances
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
